module.exports = __webpack_public_path__ + "img/logo-desktop.6c38685c.svg";